import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { useState } from "react";

import { Stack } from "@mui/system";
import { useLocation } from "react-router";
import { axiosInstance } from "src/api/axios";
import CustomTextField from "../../../components/forms/theme-elements/CustomTextField";

const cities = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttarakhand",
  "Uttar Pradesh",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and",
  "The Government of NCT of Delhi",
  "Jammu & Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];
const occupations = [
  "Bank Employee",
  "Student",
  "Financial Advisor",
  "Sales Manager",
  "DSA",
  "Influencer",
  "Professional",
  "Others",
];

const AuthRegister = ({ title, subtitle, subtext }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [occupation, setoccupation] = useState("");
  const [dob, setdob] = useState("");
  const [gender, setgender] = useState("");
  const [city, setcity] = useState("");
  const [pinCode, setpincode] = useState("");
  const [error, setError] = useState("");
  const theme = useTheme();
  const location = useLocation();

  const submit = async () => {
    setError("");
    if (!location?.state?.number) {
      console.error("Phone number is missing in location state.");
      // alert("Please verify your OTP first.");
      window.location.href = "/auth/login";
    }
    const missingFields = [];

    if (!name) missingFields.push("Name");
    if (!email) missingFields.push("Email");
    if (!occupation) missingFields.push("Occupation");
    if (!dob) missingFields.push("Date of Birth");
    if (!pinCode) missingFields.push("Pin Code");
    if (!city) missingFields.push("City");
    if (!gender) missingFields.push("Gender");

    if (missingFields.length > 0) {
      setError(`${missingFields.join(", ")} field(s) are mandatory.`);
      return;
    }
    console.log(location?.state);

    try {
      let response = await axiosInstance.post("/auth/register", {
        name,
        email,
        phoneNumber: location?.state?.number,
        occupation,
        dob,
        city,
        pinCode,
        gender,
        companyName: company,
        referralCode,
      });
      if (!response) {
        return;
      }

      let { data, status } = response;
      if (status < 202) {
        let { tokens, user } = data;
        let { access, refresh } = tokens;
        localStorage.setItem("token", access.token);
        localStorage.setItem("refresh", refresh.token);
        localStorage.setItem("store", JSON.stringify({ user }));
        window.location.href = "/dashboard";
      } else {
        setError(response.response.data.message);
      }
    } catch (e) {
      console.log(e.message);
    }
  };
  return (
    <>
      {title ? (
        <Typography fontWeight="700" variant="h2" mb={1}>
          {title}
        </Typography>
      ) : null}

      {subtext}

      <Box>
        <Stack
          mb={3}
          gap={0.5}
          sx={{ justifyContent: "space-evenly" }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              submit();
            }
          }}
        >
          <Typography
            variant="subtitle1"
            fontWeight={600}
            component="label"
            htmlFor="name"
            mb="5px"
          >
            Full Name
          </Typography>
          <CustomTextField
            id="name"
            variant="outlined"
            fullWidth
            placeholder="Name as per PAN Card"
            setState={setName}
          />

          <Typography
            variant="subtitle1"
            fontWeight={600}
            component="label"
            htmlFor="email"
            mb="5px"
            mt="5px"
          >
            Email Id
          </Typography>
          <CustomTextField
            id="email"
            variant="outlined"
            fullWidth
            placeholder="Enter your Email Address"
            setState={setEmail}
          />
          <Typography
            variant="subtitle1"
            fontWeight={600}
            component="label"
            htmlFor="email"
            mb="5px"
            mt="5px"
          >
            Company Name (Optional)
          </Typography>
          <CustomTextField
            id="email"
            variant="outlined"
            fullWidth
            placeholder="Company Name will be visible everywhere"
            setState={setCompany}
          />

          <Typography
            variant="subtitle1"
            fontWeight={600}
            component="label"
            htmlFor="email"
            mb="5px"
            mt="5px"
          >
            Referral Code (Optional)
          </Typography>
          <CustomTextField
            id="ref_code"
            variant="outlined"
            fullWidth
            placeholder="Referral Code (If any)"
            setState={setReferralCode}
          />

          <FormControl sx={{ flex: 1 }}>
            <Typography
              variant="subtitle1"
              fontWeight={600}
              component="label"
              htmlFor="occupation"
              mb="5px"
              mt="5px"
            >
              Occupation
            </Typography>

            <Select
              required
              labelId="occupation"
              id="occupation"
              label="Occupation"
              defaultValue=""
              renderValue={(selected) => {
                if (selected === "") {
                  return (
                    <span style={{ color: "#9e9e9e" }}>
                      Select your occupation
                    </span>
                  );
                }
                return selected;
              }}
              displayEmpty
              onChange={(e) => setoccupation(e.target.value)}
            >
              <MenuItem value="" disabled>
                Select your occupation
              </MenuItem>
              {occupations.map((job) => (
                <MenuItem value={job}>{job}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl>
            <Typography
              variant="subtitle1"
              fontWeight={600}
              component="label"
              htmlFor="dob"
              mb="5px"
              mt="5px"
            >
              Date of Birth
            </Typography>
            <TextField
              variant={"outlined"}
              type={"date"}
              id="dob"
              onChange={(e) => setdob(e.target.value)}
            />
          </FormControl>

          <FormControl>
            <Typography
              variant="subtitle1"
              fontWeight={600}
              component="label"
              htmlFor="gender"
              mb="5px"
              mt="5px"
            >
              Gender
            </Typography>
            <Select
              required
              labelId="gender"
              id="gender"
              label="Gender"
              onChange={(e) => setgender(e.target.value)}
              renderValue={(selected) => {
                if (selected === "") {
                  return (
                    <span style={{ color: "#9e9e9e" }}>Select your Gender</span>
                  );
                }
                return selected;
              }}
              defaultValue=""
              displayEmpty
            >
              <MenuItem value="" disabled>
                Select your Gender
              </MenuItem>
              <MenuItem value="male">Male</MenuItem>
              <MenuItem value="female">Female</MenuItem>
              <MenuItem value="other">Other</MenuItem>
            </Select>
          </FormControl>
          <FormControl>
            <Typography
              variant="subtitle1"
              fontWeight={600}
              component="label"
              htmlFor="state"
              mb="5px"
              mt="5px"
            >
              City
            </Typography>
            <Select
              required
              labelId="state"
              id="state"
              label="State"
              renderValue={(selected) => {
                if (selected === "") {
                  return (
                    <span style={{ color: "#9e9e9e" }}>Select your City</span>
                  );
                }
                return selected;
              }}
              displayEmpty
              defaultValue=""
              onChange={(e) => setcity(e.target.value)}
            >
              <MenuItem value="" disabled>
                Select your City
              </MenuItem>
              {cities.map((city) => (
                <MenuItem value={city}>{city}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <Typography
            variant="subtitle1"
            fontWeight={600}
            component="label"
            htmlFor="pin"
            mb="5px"
            mt="5px"
          >
            Pin Code
          </Typography>
          <CustomTextField
            id="pin"
            variant="outlined"
            label="pin code"
            type={"number"}
            setState={setpincode}
          />
        </Stack>
        <Typography
          variant="caption"
          fontWeight={600}
          sx={{
            color: "red",
            display: error ? "block" : "none",
          }}
        >
          {error}
        </Typography>

        <Button
          sx={{ bgcolor: theme.palette.earnpati.main, fontWeight: "bold" }}
          variant="contained"
          size="large"
          fullWidth
          onClick={submit}
        >
          Next
        </Button>
      </Box>
      {subtitle}
    </>
  );
};

export default AuthRegister;
